import { render, staticRenderFns } from "./MessageCardCelebration.vue?vue&type=template&id=79bf55a4&scoped=true&"
import script from "./MessageCardCelebration.vue?vue&type=script&lang=ts&"
export * from "./MessageCardCelebration.vue?vue&type=script&lang=ts&"
import style0 from "./MessageCardCelebration.vue?vue&type=style&index=0&id=79bf55a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79bf55a4",
  null
  
)

export default component.exports